import React from 'react';
import PropTypes from 'prop-types';
import { ForgeToast } from '@tylertech/forge-react';
import './ActionToastComponent.scss';
import { DEFAULT_TOAST_DURATION } from '../../static/constants.js';

const ActionToastComponent = ({
  isOpen,
  actionText = '',
  description,
  dismissible = false,
  duration = DEFAULT_TOAST_DURATION,
  onClick,
  onClose,
}) => {

  const handleClose = () => {
    if (!onClose) return;
    onClose();
  };

  return (
    <ForgeToast
      open={isOpen}
      duration={duration}
      dismissible={dismissible}
      className={'action-toast'}
      action-text={actionText}
      on-forge-toast-action={(e) => onClick(e)}
      on-forge-toast-close={() => handleClose()}
    >
      {description}
    </ForgeToast>
  );
};

ActionToastComponent.propTypes = {
  isOpen: PropTypes.bool,
  actionText: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func,
  duration: PropTypes.number,
  dismissible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ActionToastComponent;
